import { createApp } from 'vue'
import App from './App.vue'
import router from './public/router'
import store from './public/store'

// Arco Design Vue（暗色模式 CSS 已内置在 arco.css 中，无需额外导入）
import ArcoVue from '@arco-design/web-vue/es/index.js'
import '@arco-design/web-vue/dist/arco.css'

// 全局注册 Arco Design 图标（解决所有 icon-xxx 未注册问题）
import * as Icons from '@arco-design/web-vue/es/icon'
// SVG 图标组件
import SvgIcon from './public/components/SvgIcon'
// 大屏自适应缩放容器（jsc 等大屏页面使用 <scale-screen>）
import ScaleScreen from './public/components/ScaleScreen'

// 导入组件库
import Components from './companents'

// 导入 Fan 并注册到 Vue 实例
import { Fan } from './public/fan'

const app = createApp(App)
app.config.globalProperties.$fan = Fan

// 注册所有 Arco 图标为全局组件（支持 <icon-plus /> 等用法）
for (const [name, comp] of Object.entries(Icons)) {
  if (name.startsWith('Icon') && typeof comp === 'object') {
    // IconPlus -> icon-plus (kebab-case for template use)
    app.component(
      name.replace('Icon', 'icon').replace(/([A-Z])/g, '-$1').toLowerCase(),
      comp
    )
  }
}

// 百度地图（Vue 3 版本）：用于 FForm 的 mapPoint / amapPoint 表单类型
// 注意：vue-baidu-map-v3 的 install() 内部用了 Vue.prototype._BMap（Vue 2 写法）
//       在 Vue 3 中会崩溃，所以跳过 install，手动逐个注册组件
import {
  BaiduMap, BmView,
  BmNavigation, BmMarker,
} from 'vue-baidu-map-v3'

// 全局注册 SVG 图标组件
app.component('svg-icon', SvgIcon)

// 全局注册大屏缩放容器
app.component('scale-screen', ScaleScreen)

app.use(ArcoVue.default || ArcoVue)

// 手动注册百度地图组件（跳过 install 避免 _BMap 崩溃）
app.component('baidu-map', BaiduMap)
app.component('bm-view', BmView)
app.component('bm-navigation', BmNavigation)
app.component('bm-marker', BmMarker)

app.use(Components)
app.use(router)
app.use(store)

// 抑制无害的第三方库兼容性警告
const _origWarn = console.warn
console.warn = function (...args) {
  const msg = (args.length > 0) ? (typeof args[0] === 'string' ? args[0] : String(args[0] || '')) : ''
  // Arco Table ColGroup 的 Duplicate keys 误报
  if (msg.indexOf('Duplicate keys found') >= 0 && msg.indexOf('arco-col-template') >= 0) return
  return _origWarn.apply(console, args)
}

app.mount('#app')
